import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faArchive} from '@netx/core-icons';
import {canManageSavedCartArchive} from '../enablers';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';
import {CART_SAVED_EVENT} from './constants';

export const cartSavedActionManageArchiveArchiveIcon = faArchive;

/**
 * Manage saved cart assets archive
 * @param params
 * @returns Action
 */
export const cartSavedActionManageArchiveArchive = (
	savedCart?: ISavedCart,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-manage-archive',
	cb: () =>
		dispatcher.trigger(CART_SAVED_EVENT.MANAGE_ARCHIVE_ARCHIVE, savedCart),
	enableTest: () => canManageSavedCartArchive(savedCart),
	get label() {
		return CART_SAVED_ACTION_LABELS.MANAGE_ARCHIVE_ARCHIVE;
	},
	icon: cartSavedActionManageArchiveArchiveIcon,
	...params,
});

export default cartSavedActionManageArchiveArchive;
